<app-confirmation-modal
  [config]="confirmationBoxConfig"
  (cancel)="closeConfirmation()"
  (confirm)="onConversationClosed()"
  (secondaryAction)="closeConversationAndTurnOffModal()"
>
</app-confirmation-modal>
